import React, { useState, useEffect } from "react";
import Modal from "react-responsive-modal";
import { IoMdClose } from "react-icons/io";
import {
  useGetCountryList,
  useGetStateList,
  useSubmitTenantSetting,
} from "../../../queries/employeeQueries";
import { getFormFields,serialTypeList } from "../../../Consts/consts";
import {
  nameRegex,
  cannotStartWithSpace,
  numberRegex,
} from "../../../utils/regex/regex";
import { toast } from "react-toastify";

const regexMap = {
  name: nameRegex,
  cannotStartWithSpace: cannotStartWithSpace,
  number: numberRegex,
};

const AddTenantSetting = ({ open, close, componentKey, isEdit, editData,fetchAllTenantData }) => {
  const { data: countryList } = useGetCountryList();
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedState, setSelectedState] = useState(null);
 const { data: stateList } = useGetStateList(selectedCountry);
const stateOptions = stateList?.map((s) => ({ label: s.state_name, value: s.id })) || [];

  const countryOptions =
    countryList?.map((c) => ({ label: c.flag, value: c.id })) || [];
        
   useEffect(() => {
  if (editData?.state_id && stateList?.length) {
    setSelectedState(editData.state_id);
  }
}, [editData, stateList]);



  const formFields = getFormFields(countryOptions, stateOptions);
  const submitMutation = useSubmitTenantSetting();

  const [includedTags, setIncludedTags] = useState([]); 
  const [formData, setFormData] = useState({}); 
  const [errors, setErrors] = useState({});

  const mapApiToFormKey = (componentKey, apiItem, fKey) => {
    switch (componentKey) {
      case "jobTitleList":
        if (fKey === "jobTitleName") return apiItem.title ?? "";
        break;
      case "departmentList":
        if (fKey === "departmentName") return apiItem.title ?? "";
        break;
      case "designationList":
        if (fKey === "designationTitle") return apiItem.title ?? "";
        if (fKey === "designationDescription")
          return apiItem.description ?? "";
        break;
      case "locationList":
        if (fKey === "locationName") return apiItem.title ?? "";
        if (fKey === "CountryId") return apiItem.country ?? "";
        if (fKey === "StateId") return apiItem.state ?? "";
        break;
      case "emploeeTypeList":
        if (fKey === "employeeTypeLabel") return apiItem.title ?? "";
        break;
      case "teamList":
        if (fKey === "teamName") return apiItem.title ?? "";
        break;
      case "tenantSerialType":
        if (fKey === "prefix") return apiItem.prefix ?? "";
        if (fKey === "serialStartFrom") return apiItem.serial_start_from ?? "";
        if (fKey === "suffix") return apiItem.suffix ?? "";
        if (fKey === "serialType") {
    return serialTypeList.find((s) => s.value === apiItem.type)?.value ?? "";
  }
        break;
      default:
        return apiItem[fKey] ?? "";
    }
  };
useEffect(() => {
  if (!isEdit || !editData?.length) {
    setIncludedTags([]); 
    return;
  }
  if (includedTags.length === editData.length) return;
  if (!formFields[componentKey]?.field?.length) return;

  const mapped = editData.map((item) => {
    const obj = {};
    formFields[componentKey].field.forEach((f) => {
      obj[f.key] = mapApiToFormKey(componentKey, item, f.key);
    });
    return {
      ...obj,
      id: item.id ?? null,
      tagId: item.tagId ?? `${componentKey}_${item.id ?? Math.floor(Math.random() * 1000)}`,
    };
  });

  setIncludedTags(mapped);
  if (componentKey === "locationList" && mapped[0]) {
    const maybeCountry = mapped[0].CountryId ?? mapped[0].country ?? "";
    if (maybeCountry) setSelectedCountry(maybeCountry);
  }
}, [isEdit, editData, formFields, componentKey]);

  // Validation
  const validateField = (key, value, field) => {
    let error = "";
    if (field.required && (!value && value !== 0)) {
      error = `${field.label} is required`;
    } else if (
      field.regex &&
      value &&
      !regexMap[field.regex]?.test(value)
    ) {
      error = `${field.label} is invalid`;
    }
    setErrors((prev) => ({ ...prev, [key]: error }));
    return error === "";
  };

 // Edit
const handleInputChange = (key, value, field, idx = null) => {
  const finalValue = field?.type === "number" ? (value === "" ? "" : Number(value)) : value;
  validateField(key, finalValue, field);

  if (idx !== null) {
    setIncludedTags((prev) => {
      const updated = [...prev];
      updated[idx] = { ...updated[idx], [key]: finalValue };

      // Reset StateId when CountryId changes for this row
      if (key === "CountryId") updated[idx].StateId = null;

      return updated;
    });
  } else {
    setFormData((prev) => ({ ...prev, [key]: finalValue }));
    if (key === "CountryId") setSelectedState(null);
  }

  if (key === "CountryId") setSelectedCountry(finalValue);
};



  // Add
  const handleAddEntry = () => {
    let isValid = true;
    formFields[componentKey].field.forEach((f) => {
      if (!validateField(f.key, formData[f.key], f)) isValid = false;
    });
    if (!isValid) return;

    const tagId = `${componentKey}_${Math.floor(Math.random() * 1000)}`;
    setIncludedTags((prev) => [...prev, { ...formData, tagId }]);
    setFormData({});
    setSelectedCountry(null);
    setSelectedState(null);
  };

  // Submit handler
const handleSubmit = () => {
  let finalData = [...includedTags];
  if (!isEdit && Object.keys(formData).length) {
    finalData.push({ ...formData, id: null, tagId: `${componentKey}_${Math.floor(Math.random() * 1000)}` });
  }
  if (!finalData.length) {
    toast.info("Please add at least one entry");
    return;
  }

const payload = {
  [formFields[componentKey].key]: finalData.map((it) => ({
    ...it,
    id: it.id ?? null,
    
  })),
};

  submitMutation.mutate(payload, {
    onSuccess: (res) => {
      if (res?.status) { 
        toast.success(res.message || "Details saved successfully");
          
        fetchAllTenantData();
         close();
      }

      else { 
        toast.error(res.message || "Something went wrong");
      }
    },
    onError: (err) =>  { 
      toast.error(err?.response?.data?.message || "Somethingvv went wrong");
    }
  });
};

  const renderField = (field, value, onChange) => {
    const isError = errors[field.key];
    const commonClass = `border rounded px-2 py-1 ${
      isError ? "border-red-500" : "border-gray-300"
    }`;

    if (field.type === "select") {
      return (
        <>
          <select className={commonClass} value={value ?? ""} onChange={onChange}>
            <option value="" disabled>
              {field.placeholder}
            </option>
            {field.list?.map((opt, i) => (
              <option key={i} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
          {isError && <span className="text-red-500 text-sm">{isError}</span>}
        </>
      );
    }

    return (
      <>
        <input
          className={commonClass}
          type={field.type}
          value={value ?? ""}
          placeholder={field.placeholder}
          onChange={onChange}
        />
        {isError && <span className="text-red-500 text-sm">{isError}</span>}
      </>
    );
  };

  return (
    <Modal open={open} closeOnOverlayClick={false} showCloseIcon={false} center>
      <div className="flex flex-col gap-5 p-3 w-[500px] max-w-[90vw]">
        <div className="flex justify-between mb-3">
          <div className="flex flex-col">
            <h1 className="text-xl font-semibold mb-0">
              {isEdit ? "Edit" : "Add"} {formFields[componentKey]?.title}
            </h1>
            <span className="text-base">
              {isEdit ? "Edit existing " : "Create a new "}{" "}
              {formFields[componentKey]?.title.toLowerCase()}
            </span>
          </div>
          <button className="text-xl" onClick={close}>
            <IoMdClose />
          </button>
        </div>
        {includedTags.map((item, idx) => (
          <div
            key={item.tagId}
            className="border p-2 rounded-md mb-2 flex flex-col gap-2"
          >
            {formFields[componentKey].field.map((f) => (
              <div key={f.key} className="flex flex-col gap-1">
                <label className="font-medium text-gray-800">{f.label}</label>
              {renderField(
  f,
  f.key === "StateId" && idx === null
    ? selectedState ?? ""
    : idx !== null
    ? item[f.key]
    : formData[f.key],
  (e) => handleInputChange(f.key, e.target.value, f, idx)
)}


              </div>
            ))}
          </div>
        ))}
        {!isEdit && (
          <div className="border p-2 rounded-md mb-2 flex flex-col gap-2">
            {formFields[componentKey].field.map((f) => (
              <div key={f.key} className="flex flex-col gap-1">
                <label className="font-medium text-gray-800">{f.label}</label>
                {renderField(
                  f,
                  formData[f.key] ?? "",
                  (e) => handleInputChange(f.key, e.target.value, f)
                )}
              </div>
            ))}
            {/* <button
              type="button"
              className="btn btn--border mt-2"
              onClick={handleAddEntry}
            >
              + Add
            </button> */}
          </div>
        )}
        <div className="flex justify-end gap-3 mt-5">
          <button className="btn btn--border" onClick={close}>
            Cancel
          </button>
          <button
            className="btn"
            onClick={handleSubmit}
            disabled={submitMutation.isLoading}
          >
            {submitMutation.isLoading ? "Saving..." : "Save"}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default AddTenantSetting;
